import { createFileRoute } from '@tanstack/react-router'
import ForgotPassword from 'features/Auth/ForgotPassword/ForgotPassword.component'

export const Route = createFileRoute('/(auth)/_auth/forgot-password')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ForgotPassword />
}
